import React, { useEffect, useRef } from "react";
import { Config } from '../utils';

function normalizeImageDataUrl(file: any) {
  if (!file.source?.startsWith('data:')) return file.source;

  if (file.type.startsWith('image/')) {
    return file.source;
  }

  // fallback po ekstenziji
  let mime = 'image/jpeg';
  if (file.name.endsWith('.png')) mime = 'image/png';
  if (file.name.endsWith('.webp')) mime = 'image/webp';

  return file.source.replace('data:application/octet-stream', `data:${mime}`);
}

function openImagePreview(file: any) {
  let mime = file.type || 'application/octet-stream';

  // fallback po ekstenziji ako type nije set
  if (mime === 'application/octet-stream' && 'name' in file) {
    if (file.name.endsWith('.jpg') || file.name.endsWith('.jpeg')) mime = 'image/jpeg';
    if (file.name.endsWith('.png')) mime = 'image/png';
    if (file.name.endsWith('.webp')) mime = 'image/webp';
    if (file.name.endsWith('.pdf')) mime = 'application/pdf';
  }

  const url = URL.createObjectURL(new Blob([file], { type: mime }));

  return url;
}

async function getTempUrl(fileItem: any) {
  const response = await fetch(encodeURI(`${Config.fileStoreUrl}${fileItem?.source}`));
  if (!response.ok) throw new Error('Failed to fetch file');

  const blob = await response.blob();

  // Set MIME type explicitly
  let mime = blob.type;
  if (!mime || mime === 'application/octet-stream') {
    switch (fileItem?.type.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
        mime = 'image/jpeg';
        break;
      case 'png':
        mime = 'image/png';
        break;
      case 'webp':
        mime = 'image/webp';
        break;
      case 'pdf':
        mime = 'application/pdf';
        break;
      default:
        mime = 'application/octet-stream';
    }
  }

  return URL.createObjectURL(new Blob([blob], { type: mime }));
}

export const PdfPreview: React.FC<any> = React.memo(({ file, id }): any => {
  const urlRef = useRef<string | null>(null);

  // Generate Blob URL only once
  if (!urlRef.current) {
    urlRef.current = openImagePreview(file);
  }

  // Clean up Blob URL when component unmounts
  useEffect(() => {
    return () => {
      if (urlRef.current?.startsWith('blob:')) {
        URL.revokeObjectURL(urlRef.current);
      }
    };
  }, []);

  return (
    <object
      key={id}             // stable key
      className="h-full w-full object-cover"
      data={urlRef.current!} // stable URL, does not change
      type="application/pdf"
    >
      PDF preview unavailable
    </object>
  );
});

export { normalizeImageDataUrl, openImagePreview, getTempUrl };
